export default "__VITE_ASSET__DXqEzC0E__"